
export type ProductCategory = '전체' | '용접철망' | '개비온' | '보행매트';

export interface Product {
  id: number;
  name: string;
  category: ProductCategory;
  description: string;
  specs: string;
  image: string;
}

export const products: Product[] = [
  // 용접철망 카테고리
  {
    id: 1,
    name: '표준 용접철망',
    category: '용접철망',
    description:
      '고강도 용접 철망으로 구조물 보강 및 사면 보호에 적합한 제품입니다. 정밀 용접으로 균일한 격자 구조를 형성합니다.',
    specs: '규격: 다양한 규격 제작 가능',
    image:
      'https://public.readdy.ai/ai/img_res/fe681df3ecb4f02289ed5f0f53666b19.jpg',
  },
  {
    id: 2,
    name: '아연도금 용접철망',
    category: '용접철망',
    description:
      '고품질 아연도금 처리로 부식 방지 성능이 뛰어나며, 장기간 야외 환경에서도 내구성을 유지합니다.',
    specs: '규격: 맞춤 제작 가능',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20product%20photo%20of%20galvanized%20welded%20wire%20mesh%20panel%20with%20shiny%20zinc%20coating%2C%20showing%20corrosion%20resistant%20surface%20finish%2C%20precise%20grid%20pattern%2C%20heavy%20duty%20industrial%20quality%2C%20clean%20white%20background%2C%20studio%20lighting%2C%20technical%20product%20photography&width=800&height=600&seq=weld2&orientation=landscape',
  },
  {
    id: 3,
    name: 'PVC 코팅 용접철망',
    category: '용접철망',
    description:
      'PVC 코팅 처리로 내식성과 내후성이 우수하며, 다양한 색상 선택이 가능합니다.',
    specs: '규격: 주문 제작 가능',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20product%20photo%20of%20PVC%20coated%20welded%20wire%20mesh%20panel%20with%20green%20polymer%20coating%2C%20showing%20smooth%20protective%20surface%2C%20uniform%20grid%20structure%2C%20weather%20resistant%20finish%2C%20clean%20white%20background%2C%20studio%20product%20photography%2C%20high%20detail&width=800&height=600&seq=weld3&orientation=landscape',
  },
  // 개비온 카테고리
  {
    id: 4,
    name: '표준형 매트리스개비온',
    category: '개비온',
    description:
      '하천 호안 보호에 최적화된 표준형 제품으로 다양한 현장에 적용 가능합니다.',
    specs: '규격: 2m × 1m × 0.3m',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20product%20photo%20of%20standard%20gabion%20mattress%20with%20hexagonal%20wire%20mesh%20structure%2C%20filled%20with%20uniform%20river%20stones%2C%20flat%20rectangular%20shape%2C%20industrial%20quality%2C%20clean%20white%20background%2C%20technical%20product%20photography%2C%20high%20detail%2C%20engineering%20precision&width=800&height=600&seq=prod1&orientation=landscape',
  },
  {
    id: 5,
    name: '대형 매트리스개비온',
    category: '개비온',
    description: '대규모 하천정비 사업에 적합한 대형 규격 제품입니다.',
    specs: '규격: 3m × 2m × 0.5m',
    image:
      'https://readdy.ai/api/search-image?query=Large%20size%20gabion%20mattress%20product%20photo%20showing%20robust%20wire%20mesh%20construction%20with%20natural%20stones%2C%20heavy-duty%20industrial%20product%2C%20larger%20dimensions%2C%20clean%20white%20background%2C%20professional%20lighting%20...&width=800&height=600&seq=prod2&orientation=landscape',
  },
  {
    id: 6,
    name: '맞춤형 매트리스개비온',
    category: '개비온',
    description: '현장 특성에 맞춘 맞춤 제작 서비스를 제공합니다.',
    specs: '규격: 현장 맞춤 제작',
    image:
      'https://readdy.ai/api/search-image?query=Custom%20gabion%20mattress%20product%20showing%20flexible%20design%20options%20with%20wire%20mesh%20and%20stones%2C%20modular%20construction%2C%20adaptable%20sizing%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20engineering%20versatility%2C%20technical%20precision&width=800&height=600&seq=prod3&orientation=landscape',
  },
  // 보행매트 카테고리
  {
    id: 7,
    name: '표준 보행매트',
    category: '보행매트',
    description:
      '하천 둔치 및 산책로에 설치하는 보행용 매트로, 보행자의 안전과 편의를 제공합니다.',
    specs: '규격: 1m × 0.5m × 50mm',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20product%20photo%20of%20standard%20pedestrian%20walking%20mat%20for%20riverside%20paths%2C%20rubber%20composite%20material%20with%20anti-slip%20textured%20surface%2C%20durable%20outdoor%20walkway%20panel%2C%20dark%20gray%20color%2C%20clean%20white%20background%2C%20studio%20product%20photography%2C%20high%20detail&width=800&height=600&seq=walk1&orientation=landscape',
  },
  {
    id: 8,
    name: '친환경 보행매트',
    category: '보행매트',
    description:
      '재활용 소재를 활용한 친환경 보행매트로, 투수성이 우수하여 자연 배수가 가능합니다.',
    specs: '규격: 1m × 0.5m × 40mm',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20product%20photo%20of%20eco-friendly%20permeable%20pedestrian%20walking%20mat%20made%20from%20recycled%20materials%2C%20porous%20surface%20design%20allowing%20water%20drainage%2C%20green%20sustainable%20construction%20material%2C%20clean%20white%20background%2C%20studio%20product%20photography%2C%20high%20detail&width=800&height=600&seq=walk2&orientation=landscape',
  },
  {
    id: 9,
    name: '고강도 보행매트',
    category: '보행매트',
    description:
      '중장비 통행이 가능한 고강도 보행매트로, 공사 현장 임시 통로 및 영구 보행로에 적합합니다.',
    specs: '규격: 1.2m × 0.6m × 60mm',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20product%20photo%20of%20heavy%20duty%20high%20strength%20pedestrian%20walking%20mat%20panel%20for%20construction%20sites%2C%20reinforced%20composite%20material%20with%20rugged%20anti-slip%20surface%2C%20thick%20durable%20design%2C%20industrial%20grade%2C%20clean%20white%20background%2C%20studio%20product%20photography&width=800&height=600&seq=walk3&orientation=landscape',
  },
];

export const categoryDescriptions: Record<
  string,
  { title: string; description: string; icon: string }
> = {
  용접철망: {
    title: '용접철망',
    description: '고강도 용접 철망으로 구조물 보강, 사면 보호, 울타리 등 다양한 용도에 활용됩니다.',
    icon: 'ri-grid-line',
  },
  개비온: {
    title: '개비온',
    description: '하천 호안 보호 및 침식 방지에 최적화된 매트리스개비온 제품군입니다.',
    icon: 'ri-stack-line',
  },
  보행매트: {
    title: '보행매트',
    description: '하천 둔치, 산책로, 공사 현장 등에 설치하는 안전 보행용 매트 제품군입니다.',
    icon: 'ri-footprint-line',
  },
};

export const productFeatures = [
  {
    icon: 'ri-shield-check-line',
    title: '구조적 안정성',
    description: '하중 분산 구조로 장기간 안정적인 성능을 유지합니다.',
  },
  {
    icon: 'ri-tools-line',
    title: '우수한 시공성',
    description: '현장 조건에 맞춰 신속하고 효율적인 시공이 가능합니다.',
  },
  {
    icon: 'ri-time-line',
    title: '뛰어난 내구성',
    description: '아연도금 처리로 부식에 강하고 장기 내구성이 우수합니다.',
  },
  {
    icon: 'ri-leaf-line',
    title: '친환경성',
    description: '자연 재료 사용으로 환경 친화적이며 생태계 보전에 기여합니다.',
  },
];
